export default __webpack_public_path__ + "static/media/ko.e3fda633.svg";